import React, { useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Auth from './auth/auth';
import './Dashboard.css';

const Dashboard = () => {
  const [stats] = useState({
    today: 5,
    week: 23,
    month: 87,
    total: 342,
  });

  const statCards = [
    {
      title: "Today's Submissions",
      value: stats.today,
      change: '+12% vs yesterday',
      icon: '⚡',
      colorClass: 'stat-accent-indigo',
    },
    {
      title: 'This Week',
      value: stats.week,
      change: '+8% vs last week',
      icon: '📅',
      colorClass: 'stat-accent-cyan',
    },
    {
      title: 'This Month',
      value: stats.month,
      change: '+15% vs last month',
      icon: '📈',
      colorClass: 'stat-accent-emerald',
    },
    {
      title: 'Total Reports',
      value: stats.total,
      change: 'Lifetime metrics',
      icon: '🏆',
      colorClass: 'stat-accent-amber',
    },
  ];

  const modules = [
    {
      title: 'Daily Work Reporting',
      description: 'Manage and review daily field activities, meetings, group leader progress, and team performance.',
      link: '/daily-reporting',
      icon: '📝',
      tag: 'Core Activity',
      color: 'blue-module',
    },
    {
      title: 'Cheque Collection Reporting',
      description: 'Track cheque collections, payment receipts, ranks, DS codes, and verified leader records.',
      link: '/cheque-reporting',
      icon: '💳',
      tag: 'Finance & Verification',
      color: 'emerald-module',
    },
    {
      title: 'Diwali Bonus Reporting',
      description: 'Review festive bonus targets, annual earning achievements, task completions, and incentives.',
      link: '/diwali-reporting',
      icon: '🎉',
      tag: 'Special Campaign',
      color: 'amber-module',
    },
    {
      title: 'All Reports Explorer',
      description: 'Comprehensive table search, multi-field filtering, instant pagination, and PDF export.',
      link: '/data-table',
      icon: '📑',
      tag: 'Data Analytics',
      color: 'purple-module',
    },
  ];

  return (
    <Container fluid className="dashboard-container">
      <Auth />

      {/* Header Banner */}
      <div className="dashboard-hero-banner">
        <div className="hero-text">
          <h2 className="hero-greeting">Welcome back, Leader 👋</h2>
          <p className="hero-sub">Here is your daily activity overview and performance summary.</p>
        </div>
        <div className="hero-actions">
          <Link to="/reports/daily" className="btn-hero-primary">
            <span>➕ Submit Daily Report</span>
          </Link>
        </div>
      </div>

      {/* KPI Stats Grid */}
      <Row className="g-4 mb-4">
        {statCards.map((stat, idx) => (
          <Col key={idx} xs={12} sm={6} xl={3}>
            <Card className={`executive-kpi-card ${stat.colorClass}`}>
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <span className="kpi-label">{stat.title}</span>
                  <div className="kpi-icon-pill">{stat.icon}</div>
                </div>
                <div className="kpi-value">{stat.value}</div>
                <div className="kpi-meta">{stat.change}</div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      {/* Main Reporting Portals Section */}
      <div className="section-title-wrapper mb-3">
        <h3 className="section-title">Reporting Modules & Workspaces</h3>
        <p className="section-subtitle">Select a module to view records, filter submissions, or export data</p>
      </div>

      <Row className="g-4 mb-4">
        {modules.map((mod, idx) => (
          <Col key={idx} xs={12} md={6} xl={3}>
            <Link to={mod.link} className="module-card-link">
              <Card className={`module-card ${mod.color}`}>
                <Card.Body>
                  <div className="module-badge-row">
                    <span className="module-tag">{mod.tag}</span>
                    <span className="module-arrow">→</span>
                  </div>
                  <div className="module-icon-box">{mod.icon}</div>
                  <h4 className="module-title">{mod.title}</h4>
                  <p className="module-desc">{mod.description}</p>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Dashboard;
